import { render, staticRenderFns } from "./MtsOdemeIslemDetayView.vue?vue&type=template&id=6f55a217&scoped=true"
import script from "./MtsOdemeIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsOdemeIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55a217",
  null
  
)

export default component.exports